import { Component, OnInit } from '@angular/core';
import { NavController, Events } from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../../../UI/src/app/shared/authentication/authentication.service';
import { JobService } from '../../../../../../UI/src/app/shared/job/job.service';
import { OTPRequestDTO } from '../../../../../../UI/src/app/shared/authentication/otp-request-dto';
import { SigninComponent } from '../../authentication/components/signin/signin.component';
import { ValidationService } from '../../../../../../UI/src/app/shared/validation/validation.service';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyComponent } from "../../privacy-policy/privacy-policy.component";
import { SettingsService } from '../../../../../../UI/src/app/shared/settings/settings.service';

@Component({
  selector: 'sts-get-matched',
  templateUrl: './get-matched.component.html'
})
export class GetMatchedComponent implements OnInit {
  userIdentifier;
  inputPhoneNumber;
  requestDTO: OTPRequestDTO;
  isEmail = false;
  isPrivacyPolicy = false;
  private getmatchedForm: FormGroup;
  public isBothEnabled:boolean;
  constructor(
    public events: Events,
    private authenticationService: AuthenticationService,
    private settingsService: SettingsService,
    public navCtrl: NavController,
    private jobService: JobService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private validationService: ValidationService
  ) {

    this.getmatchedForm = this.formBuilder.group({
      'email': ['', [Validators.required, ValidationService.emailValidator]]
    });
    this.requestDTO = new OTPRequestDTO();
    this.settingsService.GetLoginSettings().subscribe(
      settings => {
        this.authenticationService.setLoginType(settings);
        this.isBothEnabled = authenticationService.getLoginType();
        this.isEmail = authenticationService.getRegistrationType();
      });
    this.enableDisablePrivacyPolicyLink();
    this.events.subscribe('enableDisablePrivacyPolicyLink', () => {
      this.enableDisablePrivacyPolicyLink();
    });
  }

  ngOnInit() {
    this.isValidForm();
  }

  createProfile() {
    if (!this.isEmail) {
      this.requestDTO.UserIdentifier = this.inputPhoneNumber;
    }
    else {
      this.requestDTO.UserIdentifier = this.userIdentifier;
    }
    this.requestDTO.IsEmail = this.isEmail;
    this.authenticationService.setIdentifier(this.requestDTO.UserIdentifier);
    this.authenticationService.setRegistrationType(this.isEmail);
    this.navCtrl.push(SigninComponent, { action: "request", userIdentifier: this.requestDTO.UserIdentifier, isEmail: this.isEmail });
  }

  changeIdentifier(isEmail) {
    this.isEmail = isEmail;
    this.authenticationService.isEmail = isEmail;
    this.authenticationService.isLoginTypeChanged = true;
    this.userIdentifier = '';
    this.isValidForm();
  }

  getPhoneNumber(userPhoneNumber) {
    this.inputPhoneNumber = userPhoneNumber;
  }

  isValidForm() {
    if (this.isEmail) {
      return this.getmatchedForm.valid;
    }
  }
  enableDisablePrivacyPolicyLink() {
    // Check if the content is present to make the link enable
    this.translate.get(['CAREER_PRIVACY_POLICY_CONTENT_TEXT'])
      .subscribe((obj) => {
        // if the policy content is not equal to '-' enable the link
        if (obj.CAREER_PRIVACY_POLICY_CONTENT_TEXT !== '-') {
          this.isPrivacyPolicy = true;
        } else {
          this.isPrivacyPolicy = false;
        }
      });
  }

  openPrivacyPolicy() {
    this.navCtrl.push(PrivacyPolicyComponent);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/get-matched/get-matched.component.ts